export interface PlanFeatureType {
  title: string;
  free: boolean;
  pro: boolean;
}

export const PLANS_ACCESS = [
  {
    title: '🙋‍♀️ 50,000+ AIs',
    free: true,
    pro: true,
  },
  {
    title: '💦  Romantic mode',
    free: false,
    pro: true,
  },
  {
    title: '📷 Unlimited photos and videos',
    free: false,
    pro: true,
  },
  {
    title: '🧠 Ultra smart AI',
    free: false,
    pro: true,
  },
  {
    title: '🔞 Unlocked messages',
    free: false,
    pro: true,
  },
  {
    title: '⏳ Long memory',
    free: false,
    pro: true,
  },
  {
    title: '⚡ Fast responses',
    free: false,
    pro: true,
  },
];

export const SAFE_PLANS_ACCESS = [
  {
    title: '🙋‍♀️ 50,000+ AIs',
    free: true,
    pro: true,
  },
  {
    title: '💖 Romantic mode',
    free: false,
    pro: true,
  },
  {
    title: '📷 Unlimited photos and videos',
    free: false,
    pro: true,
  },
  {
    title: '🧠 Ultra smart AI',
    free: false,
    pro: true,
  },
  {
    title: '💬 Unlocked messages',
    free: false,
    pro: true,
  },
  {
    title: '⏳ Long memory',
    free: false,
    pro: true,
  },
  {
    title: '⚡️️ Fast responses',
    free: false,
    pro: true,
  },
];

export const VIP_PLANS_ACCESS = [
  {
    title: '🔞 18+ photos and videos',
    free: false,
    pro: true,
  },
  {
    title: '🔥 50k+ sexy AIs to play with',
    free: false,
    pro: true,
  },
  {
    title: '💋 Custom kinks, bodies & moods',
    free: false,
    pro: true,
  },
  {
    title: '🛏️ Threesomes, taboo & more',
    free: false,
    pro: true,
  },
  {
    title: '💬 Dirty talk, sexting & voice',
    free: false,
    pro: true,
  },
];
